export default __webpack_public_path__ + "static/tucnak-cb2faca690aabb6ac83f0cd5035801a5.svg";